import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';

import {connect} from 'react-redux'
import {GetUserToken, PostToBackend} from "../../api/services";
import eConfig from '../../config';
import LoadingProcessing from "../common/LoadingProcessing";


class SettingDealerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ref: "",
            email: "",
            CurrentWallet: null,
            AgentWallet: [],
            Wallets: [],
            Agents: [],
            AgentsMap: {},
            Info: {},
            user: null,
            Role: "",
            modeTransfer:false,
            selectedTransfer:null,
            transferAmount:"",
            Information:{},
            isLoading:false
        }

    }

    async componentDidMount() {
        await this.isSupperUser()
        await this.fetchWallet();
        await this.fetchInfoAgent();
        await this.fetchInfoDealer();
        await this.fetchAgents();
        await this.findInformation();
    }

    isSupperUser = async () => {
        let user = GetUserToken();
        let tmp = this.state;
        tmp.user = user;
        tmp.email = user.Username;
        this.setState(tmp);
    }
    fetchWallet = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("wallet", conds, (data) => {
            console.log("fetchWallet :> ", data);
            _this.setState({
                Wallets: data,
            });
        });
    }
    fetchAgents = async () => {
        let _this = this;
        let conds = [];
        this.fetchingAll("agent", conds, (data) => {
            console.log("fetchAgents :> ", data);
            let ls = [];
            let lsMap = {};
            for (let i in data) {
                const row = data[i];
                //console.log("+++++++++++>> ",row.dealer," == ",_this.state.ref);
                //if(row.dealer ===_this.state.ref){
                ls.push(row);
                lsMap[row.ref] = row;
                //}
            }
            _this.setState({
                Agents: ls,
                AgentsMap: lsMap
            });
        });
    }
    fetchInfoAgent = async () => {
        let _this = this;
        let endpoint = "/api/macro-finance/info/agent";
        const hub = {
            KeySearch: this.state.user.Username
        }
        let backend = eConfig.mainBackend;
        console.log("fetchInfoAgent send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchInfoAgent response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if (data.Dealer.Ref !== "") {
                    _this.setState({
                        Info: data,
                        ref: data.Dealer.Ref,
                        CurrentWallet: data.Wallet,
                        Role: "agent"
                    })
                }
            }
        });
    }
    fetchInfoDealer = async () => {
        console.log("fetchInfoDealer state > ", this.state.user);
        let _this = this;
        let endpoint = "/api/macro-finance/info/dealer";
        const hub = {
            KeySearch: this.state.user.Username
        }
        let backend = eConfig.mainBackend;
        console.log("fetchInfoDealer send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchInfoDealer response > ", dataIn);
            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                if (data.Dealer.Ref !== "") {
                    _this.setState({
                        Info: data,
                        ref: data.Dealer.Ref,
                        CurrentWallet: data.Wallet,
                        Role: "dealer"
                    })
                }

            }
        });
    }
    fetchingAll = async (table, conds, callback) => {

        const user = GetUserToken();
        console.log("User :> ", user);

        let hub = {
            Fields: [],
            DbName: "chela",
            TableName: table,
            Conditions: conds,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/global-service/list";

        console.log("fetchingAll send > ", table, hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("fetchingAll response > ", table, dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                callback(data);

            }
        });
    }
    findInformation=async ()=>{
        let _this =this;
        const user  = GetUserToken();
        let hub = {
            RequesterUsername :user.Username,
            RequesterPhone    : user.Phone,
            RequesterRole     : user.Role,
        }
        //  /backend-ecare/api/global-service
        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-information/user";

        console.log("findInformation send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn, err) {
            console.log("findInformation response > ", dataIn);

            if (typeof dataIn.RESULT !== "undefined") {
                const data = dataIn.RESULT;
                _this.setState({
                    Information:data
                })

            }
        });
    }
    renderUserWalletList = () => {

        console.log("this.state.Agents--> ",this.state.Information)
        const user  = GetUserToken();
         if (user.Role === "agent" ||
             user.Role === "user"
         ) {
             return null
         }

         let ls = [];

        const _this = this;
        const getWallet = (ref) => {
            let myWallet = {};
            for (let i in _this.state.Wallets) {
                const row = _this.state.Wallets[i];
                if (row.accountref === ref) {
                    myWallet = row;
                }
            }
            return myWallet
        }

        const getDealerName=(refIn)=>{
            for(let i in _this.state.Information.Dealers){
                const row = _this.state.Information.Dealers[i];
                if(row.Ref ===refIn){
                    let name =row.ContactPerson || row.Ref;
                    return name
                }
            }
            return refIn
        }



        return (
            <div className="row container">
                <div className="col-xs-12">
                    <p className={"alert alert-info"} style={{fontSise:16,fontWeight:"bold"}}>List of Wallet link</p>
                    <table className={"table"}>
                        <thead>
                        <tr>
                            <th>Account Ref</th>
                            <th>Dealer</th>
                            <th>Category</th>
                            <th>Name</th>
                            <th style={{textAlign:"right"}}>Balance</th>
                            <th>Last Update</th>
                            <th>#</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.Agents.map((o, index) => {

                            let boo =false;
                            if(user.Role==="super"){
                                boo=true
                            }
                            if(user.Role==="dealer"){
                                if (o.dealer === user.Phone) {
                                    boo=true;
                                }
                            }


                            if (boo) {
                                const row = getWallet(o.ref);
                                const selectedObject={
                                    ref:row.accountref,
                                    type:row.accounttype,
                                    name:o.fullname
                                }
                                return (
                                    <tr key={index}>
                                        <td>{row.accountref}</td>
                                        <td>{getDealerName(o.dealer)}</td>
                                        <td>{row.accounttype}</td>
                                        <td>{o.fullname}</td>
                                        <td style={{textAlign:"right"}}> {"R "+parseFloat(row.amount).toFixed(2)}</td>
                                        <td>{row.date + " " + row.time}</td>
                                        <td>
                                            <a
                                                style={{cursor:"pointer"}}
                                                onClick={()=>{
                                                this.setState({
                                                    modeTransfer:true,
                                                    selectedTransfer:selectedObject,
                                                })
                                            }}>Transfer</a>
                                        </td>
                                    </tr>
                                )
                            }
                            return null
                        })}
                        </tbody>
                    </table>
                </div>

            </div>
        )

    }

    renderCurrentWallet = () => {
        if (this.state.user === null) {
            return null
        }
        if (this.state.CurrentWallet === null) {
            return null
        }

        const user=GetUserToken();
        let currWallet={};
        console.log("CURRENT WALLET: ",this.state.Wallets);
        for(let i in this.state.Wallets){
            const row =this.state.Wallets[i];
            if(user.Phone===row.accountref){
                currWallet=row;
            }

        }
        return (
            <div className={"container"} style={{marginLeft: 20}}>

                <p>
                    Category:
                    &nbsp;&nbsp;
                    <b><span style={{color: "red"}}>{user.Role}</span>
                    </b>
                </p>
                <p>
                    Ref:
                    &nbsp;&nbsp;
                    <b><span style={{color: "red"}}>{currWallet.accountref}</span>
                    </b>
                </p>
                <p>
                    Amount:
                    &nbsp;&nbsp;
                    <b><span style={{color: "red"}}>{"R " + currWallet.amount}</span>
                    </b>
                </p>
                <p>
                    Account created :
                    &nbsp;&nbsp;
                    <b><span
                        style={{color: "red"}}>{currWallet.date + " " + currWallet.time}</span>
                    </b>
                </p>
            </div>
        )
    }

    cancelTransfer=()=>{
        this.setState({
            modeTransfer:false,
            selectedTransfer:null,
            transferAmount:""
        })
    }

    submitTransfer=async ()=>{
        let _this = this;
        _this.setState({
            isLoading:true
        });

        let hub={
            SenderRef: this.state.ref,
            RecipientRef : this.state.selectedTransfer.ref,
            TransAmount : parseFloat(this.state.transferAmount),
        }

        let backend = eConfig.mainBackend;
        let endpoint = "/api/macro-finance/manage/wallet-transfer/add";

        console.log("submitTopup send > ", hub);
        await PostToBackend(hub, backend, endpoint, function (dataIn) {
            console.log("submitTopup response > ", dataIn);
                alert("Thank you,Transfer success!");
            _this.setState({
                modeTransfer:false,
                selectedTransfer:null,
                transferAmount:"",
                isLoading:false
            });

             _this.fetchWallet();
             _this.fetchInfoAgent();
             _this.fetchInfoDealer();
             _this.fetchAgents();
        });

    }

    handleTransAmount=(e)=>{
        this.setState({
            transferAmount: e.target.value
        })
    }

    renderTransfer=()=>{
        if(!this.state.modeTransfer){
            return null
        }
        return(
            <div className={"container"}>
                <p className={"alert alert-info"}>Transfer Wallet
                    <a onClick={()=>this.cancelTransfer()} className={"btn btn-dander pull-right"}>Cancel</a>
                </p>
                <p><b>From : <span style={{color:"red"}}>{this.state.ref+" ("+this.state.user.Fullname+")"}</span></b></p>
                <p><b>To : <span style={{color:"red"}}>{this.state.selectedTransfer.ref+" ("+this.state.selectedTransfer.name+")"}</span></b></p>
                <p>
                    <input
                        onChange={(e)=>this.handleTransAmount(e)}
                        value={this.state.transferAmount}
                        placeholder={"Transfer amount ..."}
                    />
                    <a onClick={()=>this.submitTransfer()}
                       className={"btn btn-primary pull-right"}>Submit</a>
                </p>
            </div>
        )
    }

    render() {

        return (


            <PageContentWallpaper {...this.props} >

                {!this.state.modeTransfer&&(
                    <div>
                        <div className="row container">
                            <div className="col-xs-12">
                                <h2>Your Current Wallet</h2>
                            </div>
                            {this.renderCurrentWallet()}
                        </div>
                        {this.renderUserWalletList()}
                    </div>
                )}


                    <div>
                        {this.renderTransfer()}
                    </div>

                <LoadingProcessing open={this.state.isLoading}/>


            </PageContentWallpaper>
        )


    }

}

const mapDispatchToProps = dispatch => ({
    dispatch: dispatch
})

const mapStateToProps = state => ({
    addingModel: state.addingModel,
    login: state.login
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingDealerComponent)